<template>
    <div class="elle-home">
        <ElementsHero :settings="heroSettings" />
        <CommonBuilder v-if="status == 'success'" :data="homeData?.elements" />
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

definePageMeta({
    pageTransition: usePageTransition()
});

const route = useRoute();
const setI18nParams = useSetI18nParams();

const { data: home, status } = await useAsyncGql({
    operation: 'home',
    variables: {
        siteId: useSiteId()
    }
});

const homeData = computed<CmsItem>(() => (home.value?.home as CmsItem) ?? {});
const heroSettings = computed(() => ({
    media: Array.isArray(homeData.value.heroMedia) ? homeData.value.heroMedia : [],
    mediaMobile: Array.isArray(homeData.value.heroMediaMobile) ? homeData.value.heroMediaMobile : [],
    video: Array.isArray(homeData.value.heroVideo) ? homeData.value.heroVideo : [],
    phrases: Array.isArray(homeData.value.heroPhrases) ? homeData.value.heroPhrases : [],
    phrasesMobile: Array.isArray(homeData.value.heroPhrasesMobile) ? homeData.value.heroPhrasesMobile : []
}));

if (home.value?.home) {
    route.meta.nuxtI18n = useLocalizedSlug(homeData.value);
    setI18nParams(useLocalizedSlug(homeData.value));
    usePageSettings(homeData.value.typeHandle, homeData.value.sectionHandle);
    useSeoData(homeData.value.seo);
} else {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
}
</script>
